<app-loader [isLoading]="loading"></app-loader>
<div *ngIf="!loading">
      <!-- AI Assistence -->
    <div class="ai-card" (click)="openAiAssistant()">
      <div class="ai-left">
        <div class="ai-icon">
          <img src="assets/img/ruralx-mitra-icon.webp" alt="Ruralx Mitra">
        </div>
        <div class="ai-content">
          <div class="ai-title">
            Ruralx Mitra
            <!-- <span class="ai-badge">AI</span> -->
          </div>
          <div class="ai-text">
            What are you looking for today?
          </div>
          <div class="ai-example">
            Try asking : "Shoes under ₹500", "Dress for an 4-year-old boy", "Mixer grinder"
          </div>
        </div>
      </div>
      <button mat-fab color="primary" class="voice-btn" (click)="openAiAssistant()">
        <mat-icon>mic</mat-icon>
      </button>
    </div>

  <div class="category-scroll" [class.at-top]="showHeaderAtTop">
    <div class="category-item" *ngFor="let chip of chipsList" (click)="onClickChips(chip.category,chip.subCategory)">
      <img class="chips-img" [src]="imageBaseUrl + chip.image[0]" [alt]="chip.subCategory" />
      <span>{{ formatCategory(chip.subCategory) | titlecase }}</span>
    </div>
  </div>
  <div class="p-1 mb-3">
    <div>
      <div id="homeBannerCarousel" class="carousel slide mb-1" data-ride="carousel" data-interval="3000">
        <div class="carousel-inner">
          <div class="carousel-item" *ngFor="let banner of bannerImages; let i=index" [class.active]="i===0">
            <div class="banner-card">
              <!-- Left Content -->
              <div class="banner-left">
                <h2>
                  New Collections<br>
                  For You
                </h2>
                <p>
                  Top Quality • Great Prices
                </p>
                <button class="shop-btn" (click)="onClickImage(banner.category,banner.subCategory)">
                  Shop Now
                </button>
              </div>
              <!-- Right Image -->
              <div class="banner-right">
                <img [src]="imageBaseUrl + banner.image" [alt]="banner.category" class="banner-img">
              </div>
            </div>
          </div>
          <div class="carousel-item">
            <div class="offer-slide">
              <div class="offer-content">
                <span class="offer-tag">FAST DELIVERY</span>
                <h3>GET YOUR ORDER</h3>
                <h2>WITHIN 24 HOURS</h2>
                <p>Fast • Reliable • Near You</p>
                <div class="offer-btn">
                  Delivery Within 24 Hours*
                </div>
              </div>
            </div>
          </div>
        </div>
        <a class="carousel-control-prev" href="#homeBannerCarousel" role="button" data-slide="prev">
        </a>
        <a class="carousel-control-next" href="#homeBannerCarousel" role="button" data-slide="next">
        </a>
      </div>
    </div>
    <div class="service-benefits" aria-label="Shopping benefits">
      <div class="service-benefit">
        <mat-icon class="benefit-delivery">local_shipping</mat-icon>
        <span><strong>FREE Delivery</strong><br>on Orders ₹299+</span>
      </div>
      <div class="service-benefit">
        <mat-icon class="benefit-time">schedule</mat-icon>
        <span><strong>Delivery Within</strong><br>24 Hours / 1 Day</span>
      </div>
      <div class="service-benefit">
        <mat-icon class="benefit-returns">verified_user</mat-icon>
        <span><strong>Easy Returns</strong><br>&amp; Refunds</span>
      </div>
      <div class="service-benefit">
        <mat-icon class="benefit-payment">payments</mat-icon>
        <span><strong>Cash on Delivery</strong><br>&amp; Online Payment</span>
      </div>
    </div>
    <div *ngFor="let category of categoryList">
      <app-product-slider [title]="category" [products]="dashboardProducts[category]">
      </app-product-slider>
    </div>
  </div>
</div>